import cloneDeep from 'lodash/cloneDeep';

const cloneCompendiumNode = function(nodeSegment) {
  // TODO: Figure out why the heck we're bothering :P
  return {
    active: nodeSegment.active,
    deeplink: nodeSegment.deeplink,
    screen: nodeSegment.screen.uri,
  };
};

const deepCloneArray = (arr) => (
  Array.isArray(arr)
    ? cloneDeep(arr)
    : []
);

const getMenuContentChildrenForRemove = ({ content, nodeRemoveId }) => {
  content.forEach((node, index) => {
    if (node.id === nodeRemoveId) {
      delete content[index];
    } else if (node?.children?.length) {
      content[index] = {
        ...cloneCompendiumNode(node),
        children: getMenuContentChildrenForRemove({
          content: node.children,
          nodeRemoveId,
        }),
      };
    } else {
      content[index] = cloneCompendiumNode(node);
    }
  });

  return content.filter((c) => !!c);
};

const getMenuContentChildrenForAddScreen = ({
  content,
  newScreen,
  screenFromNode,
}) => {
  content.forEach((node, index) => {
    if (node?.children?.length) {
      content[index] = {
        ...cloneCompendiumNode(node),
        children: getMenuContentChildrenForAddScreen({
          content: node.children,
          newScreen,
          screenFromNode,
        }),
      };
    } else {
      content[index] = cloneCompendiumNode(node);
    }
    if (node.id === screenFromNode.id) {
      const copyCh = node?.children || [];
      content[index] = {
        ...cloneCompendiumNode(node),
        children: [...copyCh, newScreen],
      };
    }
  });

  return content;
};

const getMenuContentChildren = ({ content }) => {
  content.forEach((node, index) => {
    if (node?.children?.length) {
      content[index] = {
        ...cloneCompendiumNode(node),
        children: getMenuContentChildren({
          content: node.children,
        }),
      };
    } else {
      content[index] = cloneCompendiumNode(node);
    }
  });

  return content;
};

export const getBodyCompendia = ({
  compendiaMenu,
  nodeRemoveId,
  screenFromNode,
  newScreen,
}) => {
  let children;

  if (nodeRemoveId) {
    children = getMenuContentChildrenForRemove({
      content: deepCloneArray(compendiaMenu.menu.children),
      nodeRemoveId,
    });
  } else if (newScreen) {
    children = getMenuContentChildrenForAddScreen({
      content: deepCloneArray(compendiaMenu.menu.children),
      newScreen,
      screenFromNode,
    });
  } else {
    children = getMenuContentChildren({
      content: deepCloneArray(compendiaMenu.menu.children),
    });
  }

  let contents = {
    active: compendiaMenu.menu.active,
    children,
    screen: compendiaMenu.menu.screen.uri,
    deeplink: compendiaMenu.menu.deeplink,
  };

  // Check Root
  if (newScreen && compendiaMenu.menu.screen.uri === screenFromNode.uri) {
    contents = {
      active: screenFromNode.active,
      children: [...contents.children, newScreen],
      screen: screenFromNode.uri,
    };
  }

  const body = {
    contents,
    group: compendiaMenu.group,
    id: compendiaMenu.id,
    title: compendiaMenu.title,
    uri: compendiaMenu.uri,
  };
  return body;
};

export const getThumbnailBody = ({ image, position }) => {
  const extensionSeparatorIndex = image.file_uri.lastIndexOf('.');
  const format = image.file_uri
    .substring(extensionSeparatorIndex + 1)
    .replace(/jpeg/i, 'jpg');

  const thumbnailBody = {
    image_url: image.file_uri,
    position,
    scale: image.transform.scale,
    format,
    flip: image.transform.flip,
  };
  return thumbnailBody;
};
